import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { isAdmin } from '../utils/auth';
import DentalHeroLogo from '../assets/images/Dental-Hero-Logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // Check if user has admin role
        const adminStatus = await isAdmin(currentUser.uid);
        setUserRole(adminStatus ? 'admin' : 'user');
      } else {
        setUserRole(null);
      }
      
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, [auth]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const handleDashboardClick = (e) => {
    e.preventDefault();
    
    if (user) {
      // User is authenticated, navigate to user dashboard
      navigate('/user');
    } else {
      // User is not authenticated, navigate to login page
      navigate('/login', { state: { redirectTo: '/user' } });
    }
  };
  
  const handleLogout = async (e) => {
    e.preventDefault();
    
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="bg-primary py-4">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="text-white font-heading text-2xl font-bold">
            <img src={DentalHeroLogo} alt="logo" className=" w-32" />
          </Link>
        </div>
        
        <div className="hidden md:flex items-center space-x-4">
          {user ? (
            <>
              <a 
                href="#" 
                onClick={handleDashboardClick}
                className="text-white hover:text-accent"
              >
                My Appointments
              </a>
              <a 
                href="#" 
                onClick={handleLogout}
                className="text-white hover:text-accent"
              >
                Logout
              </a>
            </>
          ) : (
            // <a 
            //   href="#"
            //   onClick={handleDashboardClick}
            //   className="text-white hover:text-accent"
            // >
            //   Login
            // </a>
            null
          )}


          <a href="/#contact-section" className="bg-white text-primary py-2 px-4 rounded-full font-medium">
            Book now
          </a>
        </div>
        
        <button 
          className="md:hidden text-white"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-primary">
          <div className="container mx-auto px-4 py-2">
            {user ? (
              <>
                <a 
                  href="#" 
                  onClick={handleDashboardClick}
                  className="block text-white py-2"
                >
                  My Appointments
                </a>
                <a 
                  href="#" 
                  onClick={handleLogout}
                  className="block text-white py-2"
                >
                  Logout
                </a>
              </>
            ) : (
              // <a 
              //   href="#"
              //   onClick={handleDashboardClick}
              //   className="block text-white py-2"
              // >
              //   Login
              // </a>
              null
            )}
            <a href="tel:07457411865" className="block text-white py-2">
              Call Us: 07457 411 865
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
